<script>
    export let selected;
    
    const federalStates = [
        {id: "bw", name: "Baden-Württemberg"},
        {id: "by", name: "Bayern"},
        {id: "be", name: "Berlin"},
        {id: "bb", name: "Brandenburg"},
        {id: "hb", name: "Bremen"},
        {id: "hh", name: "Hamburg"},
        {id: "he", name: "Hessen"},
        {id: "mv", name: "Mecklenburg-Vorpommern"},
        {id: "ni", name: "Niedersachsen"},
        {id: "nw", name: "Nordrhein-Westphalen"},
        {id: "rp", name: "Rheinland-Pfalz"},
        {id: "sl", name: "Saarland"},
        {id: "sn", name: "Sachsen"},
        {id: "st", name: "Sachsen-Anhalt"},
        {id: "sh", name: "Schleswig-Holstein"},
        {id: "th", name: "Thüringen"},
    ]

    let id = selected?.id;
    $: selected = federalStates.find((s) => s.id === id);
</script>



<label>
    <span class="label">Bundesland</span>
    <select bind:value={id}>
        <option value={undefined}> - </option>
        {#each federalStates as state}
            <option value={state.id}>{state.name}</option>
        {/each}	
    </select>
</label>

<style>
    label {
        margin-bottom: 1rem;
    }

    .label {
        display: block;
        margin-bottom: 0.2rem;
        font-size: 0.8rem;
    }

    select {
        display: block;
        border-radius: 0.5rem;
        border: 2px solid #F5F2EF;
    }
</style>